/**
 * @generated SignedSource<<628609a07adf5fdb72e0900b6293ef26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type pricingGuidanceHelpers_item$data = {
  readonly recommendedPrice: {
    readonly maxAmount: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
    readonly medianAmount: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
    readonly minAmount: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
    readonly price: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "pricingGuidanceHelpers_item";
};
export type pricingGuidanceHelpers_item$key = {
  readonly " $data"?: pricingGuidanceHelpers_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "pricingGuidanceHelpers_item"
};

(node as any).hash = "2c6c42b5a370d1864e37303253b45cb8";

export default node;
